
import { DadosEntrega } from "app/types/pesquisa-orcamento/sub-consultas-notas-fiscais/Entrega";
import globalMU from "globalMU";
import React from "react";


export type NotasFiscaisEntregaProps = {
    entrega: Partial<DadosEntrega>
}

export const NotasFiscaisEntrega = (props: NotasFiscaisEntregaProps) => {
    const corpoEntrega =
        <div className="_my-4">
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">CFOP</label>
                <p className="_mb-0 _p-2">{props.entrega.Cfop}</p>
            </div>

            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Data Saída</label>
                <p className="_mb-0 _p-2">{globalMU.formatDate(props.entrega.DataSaida)}</p>
            </div>

            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Transportadora</label>
                <p className="_mb-0 _p-2">{props.entrega.Transportadora}</p>
            </div>

            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Placa da Transportadora</label>
                <p className="_mb-0 _p-2">{props.entrega.Placa}</p>
            </div>

            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Redespacho</label>
                <p className="_mb-0 _p-2">{globalMU.formatDate(props.entrega.Redespacho)}</p>
            </div>

            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Logradouro</label>
                <p className="_mb-0 _p-2">{props.entrega.LogradouroEntrega}</p>
            </div>

            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Bairro</label>
                <p className="_mb-0 _p-2">{props.entrega.BairroEntrega}</p>
            </div>

            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Cidade</label>
                <p className="_mb-0 _p-2">{props.entrega.CidadeEntrega}</p>
            </div>

            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">UF</label>
                <p className="_mb-0 _p-2">{props.entrega.UfEntrega}</p>
            </div>

            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">CEP</label>
                <p className="_mb-0 _p-2">{props.entrega.CepEntrega}</p>
            </div>

            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Observação NF</label>
                <p className="_mb-0 _p-2">{props.entrega.Observacao}</p>
            </div>

            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Observação Orçamento</label>
                <p className="_mb-0 _p-2">{props.entrega.ObservacaoPedido}</p>
            </div>

            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Tipo Frete</label>
                <p className="_mb-0 _p-2">{props.entrega.DescricaoTipoFrete}</p>
            </div>

            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Roteiro</label>
                <p className="_mb-0 _p-2">{props.entrega.RoteiroEntrega}</p>
            </div>

            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Volume</label>
                <p className="_mb-0 _p-2">{props.entrega.Volume}</p>
            </div>

            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Peso Líquido</label>
                <p className="_mb-0 _p-2">{globalMU.formatDate(props.entrega.PesoLiquido)}</p>
            </div>

            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Peso Bruto</label>
                <p className="_mb-0 _p-2">{globalMU.formatDate(props.entrega.PesoBruto)}</p>
            </div>
        </div>

    return (
        <>
            {corpoEntrega}
        </>
    )
}